import type {UserHasSeenResponse} from '@Components/social-media-wizard/social-media-wizard.types';
import type {SocialPostCover} from '@Components/social-media/publish-params.types';
import type {SocialPostCoverParams} from '@Panels/social-media-select-cover-panel/social-media-select-cover-panel.types';
import {getFlattenedSocialPostCoverParams} from '@Panels/social-media-select-cover-panel/social-media-select-cover-panel.types';
import {getUserHasSeenCache, setUserHasSeenCache} from '@Libraries/social-media-user-seen.library';
import isNumber from 'lodash/isNumber';

const SMP_VIEW_TOGGLE_HIGHLIGHT_ADD_COVER_CACHE_KEY_PREFIX = 'smp_view_toggle_highlight_seen_';
const SMP_PREVIEW_CTA_PULSE_ADD_COVER_CACHE_KEY_PREFIX = 'smp_preview_cta_pulse_seen_';

export const generateCoverForPost = async (socialPostCoverParams: SocialPostCoverParams): Promise<SocialPostCover> => {
  const flattenedSocialPostCoverParams = getFlattenedSocialPostCoverParams(socialPostCoverParams);

  return (await window.PMW.writeLocal(`socialmedia/generateCoverForPost`, {...flattenedSocialPostCoverParams})) as SocialPostCover;
};

export const hasUserSeenSMPViewToggleHighlightForAddCover = async (): Promise<boolean> => {
  const cachedValue = getUserHasSeenCache(SMP_VIEW_TOGGLE_HIGHLIGHT_ADD_COVER_CACHE_KEY_PREFIX);

  if (cachedValue !== null) {
    return cachedValue;
  }

  if (!window.PMW.isUserLoggedIn()) {
    return false;
  }

  try {
    const data = (await window.PMW.readLocal('socialmedia/getHasUserSeenSMPViewToggleHighlight')) as UserHasSeenResponse;
    data.hasSeen = !isNumber(data.hasSeen) ? parseInt(data.hasSeen, 10) : data.hasSeen;

    setUserHasSeenCache(SMP_VIEW_TOGGLE_HIGHLIGHT_ADD_COVER_CACHE_KEY_PREFIX, data.hasSeen);
    return data.hasSeen === 1;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const markUserHasSeenSMPViewToggleHighlightForAddCover = async (): Promise<void> => {
  try {
    await window.PMW.writeLocal('socialmedia/updateUserHasSeenSMPViewToggleHighlight');
    setUserHasSeenCache(SMP_VIEW_TOGGLE_HIGHLIGHT_ADD_COVER_CACHE_KEY_PREFIX, 1);
  } catch (error) {
    console.error(error);
  }
};

export const hasUserSeenSMPPreviewCtaPulseForAddCover = async (): Promise<boolean> => {
  const cachedValue = getUserHasSeenCache(SMP_PREVIEW_CTA_PULSE_ADD_COVER_CACHE_KEY_PREFIX);

  if (cachedValue !== null) {
    return cachedValue;
  }

  if (!window.PMW.isUserLoggedIn()) {
    return false;
  }

  try {
    const data = (await window.PMW.readLocal('socialmedia/getHasUserSeenSMPPreviewCtaPulse')) as UserHasSeenResponse;
    data.hasSeen = !isNumber(data.hasSeen) ? parseInt(data.hasSeen, 10) : data.hasSeen;

    setUserHasSeenCache(SMP_PREVIEW_CTA_PULSE_ADD_COVER_CACHE_KEY_PREFIX, data.hasSeen);
    return data.hasSeen === 1;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const markUserSeenSMPPreviewCtaPulseForAddCover = async (): Promise<void> => {
  try {
    await window.PMW.writeLocal('socialmedia/updateUserHasSeenSMPPreviewCtaPulse');
    setUserHasSeenCache(SMP_PREVIEW_CTA_PULSE_ADD_COVER_CACHE_KEY_PREFIX, 1);
  } catch (error) {
    console.error(error);
  }
};
